/**
 * Created by BFR on 05/03/2020.
 */
define('filterValuesView',['module',
        'underscore',
        'marionette',
        'filterValueView'],
  function(module,
           _,
           Marionette,
           FilterValueView){
  'use strict';

  var FilterValuesView = Marionette.CollectionView.extend({
    childView: FilterValueView,
    className: 'col-md-12',

    childEvents: {
      'item:selection:change': 'onItemSelectionChange'
    },

    onItemSelectionChange: function() {
      this.trigger('item:selection:change');
    }
  });

  module.exports = FilterValuesView;
});
